import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import MODALS from 'constants/layout/modals'
import styles from './info-personal-sumary-modal.styl'

export default class InfoPersonalSummaryModal extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <MaterialModal.Body
        id={MODALS.INFO_PERSONAL_SUMMARY_MODAL}
        narrow noHeader
      >
        <MaterialModal.Content noFooter noHeader>
          <p className={styles.description}>
          <ul>
            <li>Did you have to do anything differently than planned to reach your goal?</li>
            <li>Did you face any challenges in reaching your goal?</li>
            <li>What went well?</li>
            <li>Did you learn anything about yourself through this activity?</li>
            <li>Did you notice any changes in yourself by working towards this goal?</li>
          </ul>
          </p>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
